// extracted by mini-css-extract-plugin
export default {"title":"addIncomeForm_title__S96SP","addIncome":"addIncomeForm_addIncome__A0Gm+"};